const styles = {
  container: 'py-36 sm:py-56',
  content: 'flex flex-col gap-y-2',

  head: '',

  title: 'text-8xl opacity-5 dark:opacity-20 text-center pb-4',
  description: 'text-xl text-center mt-4',

  button: {
    container: 'text-center underline',
    label: '',
  },
};

export default styles;
